import React from 'react';

const LibraryAwareLogoV2 = ({ className }) => {
  return (
      <img src={"https://d26ok4vql6q4e7.cloudfront.net/images/libraryaware_logo_s3.png"} alt="Library Aware Logo" className={className} />
  );
};

export default LibraryAwareLogoV2;